import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bcd89ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "score-graph-card-content"
}
const _hoisted_2 = { class: "content--score--loading" }
const _hoisted_3 = { class: "content--graph" }
const _hoisted_4 = {
  key: 1,
  id: "score-graph-card-content"
}
const _hoisted_5 = { class: "content--score" }
const _hoisted_6 = {
  "data-testid": "fm-dash-graph-score",
  class: "score-value"
}
const _hoisted_7 = { class: "change" }
const _hoisted_8 = { class: "change__period" }
const _hoisted_9 = { class: "content--graph" }
const _hoisted_10 = {
  key: 0,
  class: "goal"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "line-chart" }

import { computed } from 'vue'
import { faChartMixed } from 'fontawesome/pro-regular-svg-icons'
import { faArrowDown, faArrowUp } from 'fontawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import Skeleton from 'primevue/skeleton'
import DashedGoalLine from '@/assets/img/Icons/dashed-goal-line.svg'
import { GraphData } from '@/entities/frontlineManagerDash'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import LineChart from '@/components/FrontlineManagerDash/LineChart.vue'
import { formatScoreWithPercentage } from '@/utils/number'

interface Props {
    isFiveScore: boolean
    csatInPercentage: boolean
    filterTimeLabel: string
    graphData: GraphData | undefined
    metric: string
    loading: boolean
    showError?: boolean
    onReloadClick?: Function
    graphSummary?: {
        total?: number
        nps?: number
        change?: number
    }
    decimals: {
        nps: number
        csat: number
        fivestar: number
        ces: number
    }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ScoreGraphCard',
  props: {
    isFiveScore: { type: Boolean },
    csatInPercentage: { type: Boolean },
    filterTimeLabel: {},
    graphData: {},
    metric: {},
    loading: { type: Boolean },
    showError: { type: Boolean },
    onReloadClick: { type: Function },
    graphSummary: {},
    decimals: {}
  },
  setup(__props: any) {

const props = __props

const goal = computed(() => {
    return props.graphData?.target
})

const totalResponses = computed(() => {
    return props.graphSummary?.total ?? 0
})

const npsChange = computed(() => {
    const change = Number(props.graphSummary?.change ?? 0)
    return change || 0
})

const cxScore = computed(() => {
    return props.graphSummary?.nps ?? 'N/A'
})

const questionTypeTitle = computed(() => {
    if (!props || !props.metric) {
        return 'NPS'
    }
    if (props.metric === 'fivestar') {
        return 'Five Star'
    }
    return props.metric?.toUpperCase() ?? ''
})

const questionTypeHeader = computed(() => {
    return questionTypeTitle.value + ' Score'
})

const periodLabel = computed(() => {
    const timelabel = props.filterTimeLabel

    if (npsChange.value === 0 || !npsChange.value) {
        if (timelabel === 'today') {
            return 'No changes today'
        }
        return 'No change since ' + timelabel
    }

    if (timelabel === 'today') {
        return 'Today'
    } else {
        return 'vs last ' + timelabel
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardCard, {
    id: "frontline-manager-dash-score-graph-card",
    icon: _unref(faChartMixed),
    title: questionTypeHeader.value,
    "response-count": totalResponses.value,
    "show-error": _ctx.showError,
    "on-reload-click": _ctx.onReloadClick
  }, {
    content: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Skeleton), {
                height: "55px",
                width: "120px",
                "border-radius": "12px"
              }),
              _createVNode(_unref(Skeleton), {
                height: "35px",
                width: "120px",
                "border-radius": "12px"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Skeleton), {
                height: "160px",
                "border-radius": "12px"
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatScoreWithPercentage)(
                                cxScore.value,
                                _ctx.isFiveScore,
                                _ctx.csatInPercentage,
                                _ctx.metric,
                                _ctx.decimals
                            )), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["change__value", {
                                positive: npsChange.value > 0,
                                negative: npsChange.value < 0,
                            }])
                }, [
                  (npsChange.value > 0)
                    ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                        key: 0,
                        icon: _unref(faArrowUp),
                        size: "sm"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  (npsChange.value < 0)
                    ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                        key: 1,
                        icon: _unref(faArrowDown),
                        size: "sm"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_unref(formatScoreWithPercentage)(
                                    npsChange.value,
                                    _ctx.isFiveScore,
                                    _ctx.csatInPercentage,
                                    _ctx.metric,
                                    _ctx.decimals
                                )), 1)
                ], 2),
                _createElementVNode("div", _hoisted_8, _toDisplayString(periodLabel.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (goal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _unref(DashedGoalLine),
                      alt: "goal line"
                    }, null, 8, _hoisted_11),
                    _createTextVNode(" Goal " + _toDisplayString(questionTypeTitle.value) + " " + _toDisplayString(goal.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.graphData)
                  ? (_openBlock(), _createBlock(LineChart, {
                      key: 0,
                      "graph-data": _ctx.graphData,
                      metric: _ctx.metric,
                      "metric-title": questionTypeTitle.value,
                      "is-five-score": _ctx.isFiveScore,
                      "csat-in-percentage": _ctx.csatInPercentage,
                      decimals: _ctx.decimals
                    }, null, 8, ["graph-data", "metric", "metric-title", "is-five-score", "csat-in-percentage", "decimals"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["icon", "title", "response-count", "show-error", "on-reload-click"]))
}
}

})